export type ActionFields = 'basic' | 'all'

// eslint-disable-next-line unused-imports/no-unused-vars
export const actionGQLFields = (fields: ActionFields): string => {
  return `
    status
  `
}
